module.exports = flarum.core.compat['components/Notification'];